import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '../lib/cn.js';
const Root = PopoverPrimitive.Root;
const Trigger = PopoverPrimitive.Trigger;
const Anchor = PopoverPrimitive.Anchor;
const Portal = PopoverPrimitive.Portal;
const Close = PopoverPrimitive.Close;
const contentStyles = 'z-50 rounded-[var(--radius-3)] border border-[var(--color-border-default)] bg-[var(--color-surface-raised)] p-3 text-[var(--color-text-primary)] shadow-md outline-none';
const Content = React.forwardRef(({ className, sideOffset = 6, align = 'start', ...props }, ref) => (_jsx(PopoverPrimitive.Portal, { children: _jsx(PopoverPrimitive.Content, { ref: ref, sideOffset: sideOffset, align: align, className: cn(contentStyles, className), ...props }) })));
Content.displayName = 'Popover.Content';
export const Popover = Object.assign(Root, {
    Root,
    Trigger,
    Anchor,
    Portal,
    Close,
    Content,
});
//# sourceMappingURL=popover.js.map